import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="25" cy="25" r="24" fill="white" fillOpacity="0.5" />
        <circle cx="25" cy="25" r="24.5" stroke="white" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9999 29.9201V32.9201C34.0022 33.4832 33.767 34.0213 33.352 34.402C32.937 34.7827 32.3808 34.9708 31.8199 34.9201C28.7428 34.5857 25.7869 33.5342 23.1899 31.8501C20.7738 30.3148 18.7253 28.2663 17.1899 25.8501C15.4999 23.2413 14.4482 20.2711 14.1199 17.1801C14.0694 16.621 14.2562 16.0664 14.6347 15.6517C15.0132 15.2371 15.5485 15.0006 16.1099 15.0001H19.1099C20.1138 14.9902 20.9694 15.7261 21.1099 16.7201C21.2366 17.6802 21.4714 18.6228 21.8099 19.5301C22.0847 20.261 21.909 21.0849 21.3599 21.6401L20.0899 22.9101C21.5135 25.4136 23.5864 27.4865 26.0899 28.9101L27.3599 27.6401C27.9151 27.0911 28.7391 26.9154 29.4699 27.1901C30.3772 27.5286 31.3199 27.7635 32.2799 27.8901C33.2855 28.032 34.0251 28.9049 33.9999 29.9201Z"
        stroke="#111111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_b"
          x="-10"
          y="-10"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
